export default __webpack_public_path__ + "static/media/real-life-TOM2LAMBI.f3b78e8d.mp3";